'use client';

// Ayuda de "Guardar como PDF" para la exportación de minutas.
//
// La exportación a PDF abre una ventana aparte con el .docx renderizado e invoca
// el diálogo de impresión del navegador. La instrucción de elegir «Guardar como
// PDF» va DENTRO de esa ventana (y no como aviso central de la app) por dos
// razones: (1) el diálogo de impresión vive ahí, así que es donde el usuario está
// mirando; y (2) un aviso central quedaba abierto en la app estorbando al volver.
// Se oculta al imprimir (@media print), de modo que NO aparece en el PDF.

const TEXTO = 'Para guardar el documento elija «Guardar como PDF» en el diálogo de impresión. Este aviso no se imprime.';

/**
 * Inserta el banner de ayuda al inicio del cuerpo de la ventana de impresión.
 * Llamar DESPUÉS de `renderAsync`, que limpia el contenedor donde se dibuja.
 */
export function bannerImpresion(w: Window) {
  const estilo = w.document.createElement('style');
  estilo.textContent = `
    .aviso-impresion {
      position: sticky; top: 0; z-index: 10;
      padding: 10px 16px;
      background: #15803d; color: #fff;
      font: 600 13px/1.35 system-ui, -apple-system, "Segoe UI", sans-serif;
      text-align: center;
    }
    @media print { .aviso-impresion { display: none !important; } }
  `;
  w.document.head.appendChild(estilo);

  const aviso = w.document.createElement('div');
  aviso.className = 'aviso-impresion';
  aviso.textContent = TEXTO;
  w.document.body.insertBefore(aviso, w.document.body.firstChild);
}
